import React from 'react';
import { useTranslation } from 'react-i18next';
import { BenefitsTabName } from '@epi-constants/beneficiary';
import { Benefits, PersonalData } from '../../BeneficiaryDetail/components';

export const useBeneficiaryTabs = (isAdd: boolean) => {
  const { t } = useTranslation();

  const tabs = [
    {
      name: BenefitsTabName.personalData,
      label: t('containers.beneficiaries.detail.personal_data'),
      id: 'tab-personal-data',
      body: <PersonalData isAdd={isAdd} />
    },
    {
      name: BenefitsTabName.benefits,
      label: t('containers.beneficiaries.detail.benefits'),
      id: 'tab-benefits',
      body: <Benefits isAddMode={isAdd} />
    }
  ];
  return {
    tabs
  };
};
